<template>
    <div class="Background">

    <h2 class="Title">
      템플릿
    </h2>

      <TemplateList />

  </div>
  </template>
  
  <script>
  import TemplateList from '@/components/template/TemplateList.vue';
  
  export default {
    components: {
      TemplateList
    },
  }
  </script>
  
  <style lang="scss" scoped></style>